import { api } from "data";
import { useCustomQuery } from "data/modules/api/hooks/useCustomQuery";

export const useCheckGoogleMeetValidity = (props) => {
  const { onError, onSuccess } = props ?? {};
  return useCustomQuery({
    url: api.check_google_integration,
    queryKey: "check_google_integration",
    onError: onError ? onError : () => null,
    onSuccess: onSuccess ? onSuccess : () => null,
  });
};
